import styled from 'styled-components';

export const BoxInput = styled.div`
  width: 100%;
`;

export const TitleInput = styled.span`
  margin: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  display: block;
`;